var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("IP 封禁全局配置")])]
          ),
          _c(
            "el-form",
            {
              ref: "configForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
                size: "small",
              },
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("基础设置"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "功能总开关", prop: "isEnabled" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.form.isEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isEnabled", $$v)
                      },
                      expression: "form.isEnabled",
                    },
                  }),
                  _c("p", { staticClass: "from-tips" }, [
                    _vm._v("关闭后自动封禁与手工黑名单全部失效"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "封禁策略", prop: "banStrategy" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.banStrategy,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "banStrategy", $$v)
                        },
                        expression: "form.banStrategy",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "BLOCK_ALL" } }, [
                        _vm._v("BLOCK_ALL（全面阻断，拒绝所有请求）"),
                      ]),
                      _c("el-radio", { attrs: { label: "ALLOW_GET" } }, [
                        _vm._v("ALLOW_GET（允许 GET，阻断写操作）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "全局限流阈值", prop: "globalRateLimit" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 1,
                      max: 100000,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.globalRateLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "globalRateLimit", $$v)
                      },
                      expression: "form.globalRateLimit",
                    },
                  }),
                  _c("span", { staticClass: "ipt-unit" }, [
                    _vm._v("次 / 分钟"),
                  ]),
                  _c("p", { staticClass: "from-tips" }, [
                    _vm._v("单个 IP 每分钟请求超过此值将触发自动封禁"),
                  ]),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("阶梯封禁时长"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "第 1 次封禁时长", prop: "banTtlFirst" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 60,
                      max: 2592000,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.banTtlFirst,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "banTtlFirst", $$v)
                      },
                      expression: "form.banTtlFirst",
                    },
                  }),
                  _c("span", { staticClass: "ipt-unit" }, [_vm._v("秒")]),
                  _c("span", { staticClass: "ipt-convert" }, [
                    _vm._v(_vm._s(_vm.formatSeconds(_vm.form.banTtlFirst))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "第 2 次封禁时长", prop: "banTtlSecond" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 60,
                      max: 2592000,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.banTtlSecond,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "banTtlSecond", $$v)
                      },
                      expression: "form.banTtlSecond",
                    },
                  }),
                  _c("span", { staticClass: "ipt-unit" }, [_vm._v("秒")]),
                  _c("span", { staticClass: "ipt-convert" }, [
                    _vm._v(_vm._s(_vm.formatSeconds(_vm.form.banTtlSecond))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "第 3 次及以上", prop: "banTtlMax" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 60,
                      max: 2592000,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.banTtlMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "banTtlMax", $$v)
                      },
                      expression: "form.banTtlMax",
                    },
                  }),
                  _c("span", { staticClass: "ipt-unit" }, [_vm._v("秒")]),
                  _c("span", { staticClass: "ipt-convert" }, [
                    _vm._v(_vm._s(_vm.formatSeconds(_vm.form.banTtlMax))),
                  ]),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("POST 白名单"),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "POST 白名单 URI",
                    prop: "postAllowlistText",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      disabled: _vm.form.banStrategy !== "ALLOW_GET",
                      placeholder:
                        "/api/front/order/preview&#10;/api/front/cart/settlement",
                    },
                    model: {
                      value: _vm.form.postAllowlistText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "postAllowlistText", $$v)
                      },
                      expression: "form.postAllowlistText",
                    },
                  }),
                  _vm.form.banStrategy !== "ALLOW_GET"
                    ? _c(
                        "p",
                        {
                          staticClass: "from-tips",
                          staticStyle: { color: "#E6A23C" },
                        },
                        [
                          _vm._v(
                            " 仅在 ALLOW_GET 策略下生效，当前策略为 BLOCK_ALL，此配置不会生效 "
                          ),
                        ]
                      )
                    : _c("p", { staticClass: "from-tips" }, [
                        _vm._v(
                          " 每行一个 URI，精确匹配，不支持通配符。已配置 " +
                            _vm._s(_vm.postAllowlistCount) +
                            " 条 "
                        ),
                      ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:ip:ban:config:update"],
                          expression: "['platform:ip:ban:config:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存配置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }